import { recognitionURL } from '../endpoints';
import PromiseCache from '../utils/promise-cache';
import FetchWithAuth from '../utils/fetch-with-auth';
function RecognitionService(authState) {
  const fetch = new FetchWithAuth(authState);
  const cache = new PromiseCache(authState);
  async function searchRewardChoices(filters = {}) {
    return await cache('searchRewardChoices', async () => {
      const res = await fetch(`${recognitionURL}/reward-choices/search`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(filters)
      });
      const {
        rewardChoices
      } = await res.json();
      return rewardChoices;
    })();
  }
  return {
    searchRewardChoices
  };
}
export default RecognitionService;
//# sourceMappingURL=recognition.js.map